import React from 'react';
import { BrowserRouter  , HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import MainApp from './MainApp';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HashRouter>
        <MainApp />
      </HashRouter>
    </ThemeProvider>
  );
}

export default App; 